<style lang="scss" scoped>
.category-card {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .image-wrapper {
        width: 100%;
        padding-top: 75%;
        position: relative;
        overflow: hidden;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
            object-position: center;
            transition: transform 0.2s;
        }
    }

    .content-wrapper {
        padding: 24px;
        background-color: #fff;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h3 {
            color: #1b1c1f;
            font-size: 1.25rem;
            font-weight: 700;
            line-height: 1.9375rem;
            margin-bottom: 16px;
        }

        p {
            color: #2b5182;
            font-size: 0.875rem;
            font-weight: 500;
            line-height: 1.375rem;
            display: inline-flex;
            align-items: center;

            span {
                margin-left: 8px;
                padding-top: 5px;
                transition: margin-left 0.2s;

                ::v-deep svg {
                    width: auto;
                    height: 8px;
                    fill: currentColor;
                }
            }
        }
    }

    &:hover {
        img {
            transform: scale(1.1);
        }

        p {
            span {
                margin-left: 12px;
            }
        }
    }

    .top-label {
        position: absolute;
        top: 8px;
        right: 8px;
        background-color: #2b5182;
        border-radius: 2px;
        color: #fff;
        font-size: 1rem;
        font-weight: 700;
        padding: 4px 8px;
    }
}
</style>

<template>
    <a class="category-card" :href="link">
        <div class="image-wrapper">
            <img :data-src="image" class="lazyload" :alt="title" />
            <span class="top-label" v-if="translations && isTop">{{ translations.is_top }}</span>
        </div>
        <div class="content-wrapper">
            <h3>{{ title }}</h3>
            <p>{{ readMore }}<span v-html="svg('arrow-right')"></span></p>
        </div>
    </a>
</template>

<script>
import cardBase from '@mixins/components/card-base';

export default {
    name: 'Cards.CategoryCard',

    mixins: [cardBase],

    computed: {
        translations() {
            return this.$store.getters['general/generalData'].product_details;
        },
    },
};
</script>
